import React from 'react';
import { motion } from 'framer-motion';
import { Briefcase } from 'lucide-react';
export function Projects() {
  return <div className="bg-[#FAF9F7] min-h-screen pb-24" data-id="element-367">
      <div className="bg-[#4A0000] py-16 text-center" data-id="element-368">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-4xl md:text-5xl font-bold text-white font-serif" data-id="element-369">
          Sponsored Projects
        </motion.h1>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 mt-16" data-id="element-370">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-12 text-center" data-id="element-371">
          <div className="w-20 h-20 bg-[#800000]/10 rounded-full flex items-center justify-center mx-auto mb-6 text-[#800000]" data-id="element-372">
            <Briefcase size={40} data-id="element-373" />
          </div>
          <h2 className="text-2xl font-bold text-gray-900 font-serif mb-4" data-id="element-374">
            Research Projects Portfolio
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto mb-8" data-id="element-375">
            Our laboratory is supported by various government agencies and
            industry partners. We have successfully completed and are currently
            executing multiple high-impact research projects in the domain of
            thermal management.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left mt-12 border-t border-gray-100 pt-12" data-id="element-376">
            <div className="p-6 bg-[#FAF9F7] rounded-xl border border-gray-200" data-id="element-377">
              <h3 className="font-bold text-[#800000] text-xl mb-2" data-id="element-378">15+</h3>
              <p className="text-gray-700 font-medium" data-id="element-379">Total Projects</p>
            </div>
            <div className="p-6 bg-[#FAF9F7] rounded-xl border border-gray-200" data-id="element-380">
              <h3 className="font-bold text-[#800000] text-xl mb-2" data-id="element-381">₹10Cr+</h3>
              <p className="text-gray-700 font-medium" data-id="element-382">Research Funding</p>
            </div>
            <div className="p-6 bg-[#FAF9F7] rounded-xl border border-gray-200" data-id="element-383">
              <h3 className="font-bold text-[#800000] text-xl mb-2" data-id="element-384">Active</h3>
              <p className="text-gray-700 font-medium" data-id="element-385">
                Industry Collaborations
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}